import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss']
})
export class StepperComponent implements OnInit {

  @Input()
  title: string = '';

  @Input()
  stepsList: any[] = [];

  @Input()
  labelName: string = '';

  @Input()
  labelStep: string = '';

  @Input()
  currentStep: number = 1;

  constructor() { }

  ngOnInit(): void {
  }

  progress(step: number){
    let numberItems = this.stepsList.length;
    let percent = 0;
    if(numberItems && numberItems > 0 ){
      percent = 100 / numberItems;
    }
    
    return percent * step;
  }

}
